<template>
  <div id="device_tab"
       class="main-tab main-tab-o">
    <div class="dv-con-content">
      <img src="../assets/images/icon_con_bg.png"
           class="img-con-bg">
      <div class="dv-con-items">
        <div class="tv-title">为您的健康 我们一直在这里——您身边的安心医院</div>
        <div class="dv-con-infos">
          <img src="../assets/images/icon_con_di.png"
               class="img-con-di">
          <div class="dv-con-item">
            <span class="tv-con-title">医院地址</span>
            <span class="tv-con-title-1">{{ info.address }}</span>
            <span class="tv-con-title"
                  style="margin-top: 30px;">客服联系</span>
            <span class="tv-con-title-1">微信公众号：{{ info.wechat_account }}</span>
            <span class="tv-con-title-1">24小时值班电话：{{ info.telephone }}</span>
          </div>
          <div class="dv-con-item">
            <span class="tv-con-title">交通路线</span>
            <div class="tv-con-title-1">{{ info.traffic }}</div>

          </div>
        </div>
      </div>
      <div class="dv-map"
           id="map"></div>
    </div>

  </div>

</template>

<script>
import api from '../api/api'
export default {
  data () {
    return {
      info: '',
    }
  },
  created () {
    this.contactdetail()
  },
  methods: {
    // 地图初始化函数，本例取名为init，开发者可根据实际情况定义
    initMap () {
      // 定义地图中心点坐标
      var center = new window.TMap.LatLng(39.025073, 121.709354)
      // 定义map变量，调用 TMap.Map() 构造函数创建地图
      var map = new window.TMap.Map(document.getElementById('map'), {
        center: center, // 设置地图中心点坐标
        zoom: 17, // 设置地图缩放级别
        pitch: 43.5, // 设置俯仰角
        rotation: 90 // 设置地图旋转角度
      })
      var markerLayer = new TMap.MultiMarker({
        map: map,  //指定地图容器
        //样式定义
        styles: {
          //创建一个styleId为"myStyle"的样式（styles的子属性名即为styleId）
          "myStyle": new TMap.MarkerStyle({
            "width": 25,  // 点标记样式宽度（像素）
            "height": 35, // 点标记样式高度（像素）
            "src": '../img/marker.png',  //图片路径
            //焦点在图片中的像素位置，一般大头针类似形式的图片以针尖位置做为焦点，圆形点以圆心位置为焦点
            "anchor": { x: 16, y: 32 }
          })
        },
        //点标记数据数组
        geometries: [{
          "id": "1",   //点标记唯一标识，后续如果有删除、修改位置等操作，都需要此id
          "styleId": 'myStyle',  //指定样式id
          "position": new TMap.LatLng(39.025073, 121.709354),  //点标记坐标位置
          "properties": {//自定义属性
            "title": "marker1"
          }
        }
        ]
      });

    },

    //招聘信息列表
    contactdetail () {
      let parm = {
        FKEY: api.getFKEY(),

      }
      api.contactdetail(parm).then((res) => {
        this.info = res.data
      })
    },
  },
  mounted () {
    this.initMap()
  }

}
</script>

<style>
.dv-con-content {
  width: 100%;
  height: fit-content;
  position: relative;
  min-height: 1000px;
  display: flex;
  flex-direction: column;
}
.img-con-bg {
  position: absolute;
  /* top: 40px; */
  width: 100%;
}
.dv-con-items {
  width: calc(100% - 600px);
  margin-left: 300px;
  margin-top: 40px;
  display: flex;
  flex-direction: column;
}
.dv-con-infos {
  width: 100%;

  background: white;
  margin-top: 50px;
  box-shadow: 0px 8px 34.2px 0.8px rgba(235, 231, 244, 0.48);
  display: flex;
  flex-direction: row;
  position: relative;
}
.img-con-di {
  width: 50%;
  left: 25%;
  position: absolute;
  bottom: 0;
}
.dv-con-item {
  width: 50%;
  display: flex;
  padding: 30px;
  flex-direction: column;
}
.tv-con-title {
  font-size: 28px;
  font-family: PingFang SC, PingFang SC-Semibold;
  font-weight: 600;
  text-align: left;
  margin-bottom: 20px;
  color: #8271ae;
}
.tv-con-title-1 {
  font-size: 22px;
  font-family: PingFang SC, PingFang SC-Semibold;
  font-weight: 400;
  text-align: left;
  margin-bottom: 20px;
  line-height: 40px;
  white-space: pre-wrap;
  color: #333333;
}
.dv-map {
  width: 100%;
  height: 700px;
  /* background: #8271ae; */
}
</style>